import PropTypes from 'prop-types';
import React from 'react';

const TabPanel = ({ children, labelledby, ...otherProps }) => (
  <section role='tabpanel' aria-labelledby={labelledby} {...otherProps}>
    {children}
  </section>
);

TabPanel.defaultProps = {
  children: null,
};

TabPanel.propTypes = {
  children: PropTypes.node,
  labelledby: PropTypes.string.isRequired,
};

export default TabPanel;
